import { toastr } from "react-redux-toastr";
import { client_v2, getApiErrorMessage } from "utils/api";

export const getWarehouse = async (id) => {
  try {
    const { data } = await client_v2.get(`/warehouses/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const createWarehouse = async ({
  name,
  street,
  zip_code,
  city,
  country_code,
  is_virtual,
}) => {
  try {
    await client_v2.post("/warehouses", {
      name,
      street,
      zip_code,
      city,
      country_code,
      is_virtual,
    });

    toastr.success("Sukces", "Magazyn został dodany");
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd podczas aktualizowania");
    throw error;
  }
};

export const updateWarehouse = async (
  id,
  { name, street, zip_code, city, country_code, is_virtual, erp_id }
) => {
  try {
    await client_v2.put(`/warehouses/${id}`, {
      name,
      street,
      zip_code,
      city,
      country_code,
      is_virtual,
      erp_id,
    });

    toastr.success("Sukces", "Magazyn został zaktualizowany");
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd podczas aktualizowania");
    throw error;
  }
};

export const deleteWarehouse = async (id) => {
  try {
    await client_v2.delete(`/warehouses/${id}`);

    toastr.success("Sukces", "Magazyn został usunięty");
  } catch (error) {
    toastr.error(
      "Błąd",
      getApiErrorMessage(error, "Wystąpił błąd podczas usuwania")
    );
    throw error;
  }
};
